import { Check } from "lucide-react";

const NATURE_IMG =
  "https://images.unsplash.com/photo-1547736388-1b87be7a1ada?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAzMzJ8MHwxfHNlYXJjaHwzfHxzdW5saWdodCUyMGZpbHRlcmluZyUyMHRocm91Z2glMjBncmVlbiUyMGxlYXZlcyUyMG5hdHVyZXxlbnwwfHx8fDE3ODE0NTY2MDJ8MA&ixlib=rb-4.1.0&q=85";

const features = [
  "Easy-to-use liquid format",
  "High-quality Vitamin D3 formulation",
  "Designed for daily use",
  "Precise dosing with dropper convenience",
  "Suitable for modern lifestyles with limited sun exposure",
];

export const Features = () => {
  return (
    <section
      data-testid="features-section"
      className="py-24 md:py-32 bg-[#FDFBF7] border-t border-[#E5E8E3]"
    >
      <div className="max-w-7xl mx-auto px-6 md:px-12 grid grid-cols-1 lg:grid-cols-12 gap-12 lg:gap-16 items-center">
        <div className="lg:col-span-5 order-2 lg:order-1">
          <div className="relative">
            <img
              src={NATURE_IMG}
              alt="Sunlight filtering through green leaves"
              data-testid="features-image"
              className="w-full h-[420px] md:h-[520px] object-cover"
            />
            <div className="absolute inset-0 ring-1 ring-inset ring-[#C29B62]/30 pointer-events-none" />
            <div className="absolute -bottom-6 -left-6 hidden md:block bg-[#1A362D] text-[#FDFBF7] px-6 py-4">
              <div className="font-serif-display text-3xl leading-none">D3</div>
              <div className="text-[10px] uppercase tracking-[0.25em] mt-1 text-[#C29B62]">Sunshine in a drop</div>
            </div>
          </div>
        </div>

        <div className="lg:col-span-7 order-1 lg:order-2">
          <div className="flex items-center gap-3 mb-6">
            <span className="ah-hairline" />
            <span className="text-xs uppercase tracking-[0.28em] font-semibold text-[#1A362D]">
              Why Choose Activehuman
            </span>
          </div>
          <h2 className="font-serif-display text-4xl md:text-5xl lg:text-[56px] text-[#1A362D] leading-[1.08] tracking-tight font-medium">
            Thoughtful by design. <em className="italic text-[#C29B62] font-normal">Simple</em> by intention.
          </h2>
          <p className="mt-6 text-base md:text-lg text-[#4A5D56] font-light leading-relaxed max-w-xl">
            A clean, convenient way to add Vitamin D3 to your day — without the complexity of pills, gummies or
            unnecessary additions.
          </p>

          <ul className="mt-10 space-y-5">
            {features.map((f, i) => (
              <li
                key={i}
                data-testid={`feature-item-${i + 1}`}
                className="flex items-start gap-4 group"
              >
                <span className="mt-1 flex-shrink-0 w-7 h-7 flex items-center justify-center border border-[#C29B62] text-[#C29B62] transition-colors duration-300 group-hover:bg-[#C29B62] group-hover:text-[#FDFBF7]">
                  <Check className="w-4 h-4" strokeWidth={1.75} />
                </span>
                <span className="text-base md:text-lg text-[#1A362D] font-light leading-relaxed">{f}</span>
              </li>
            ))}
          </ul>
        </div>
      </div>
    </section>
  );
};
